import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/cost-center-list.component.html',
})
export class CostCenterListComponent implements OnInit {
  @Input()
  ACC_NO: any;

  @Input()
  modalShow: boolean = true;

  @Input()
  selectCostCenterForCostCenterForCR;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "CostCenterListGrid"

  dataObj: any;
  costCenterList: any[] = [];
  searchFields: any[] = ['COST_NAME', 'COST_NO'];
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    private dataLoadService: DataLoadService,
    public gridService:GridService) { 
      this.colObj = [
        { headerName: langService.langData.costCenter, field: 'COST_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.costNo, field: 'COST_NO', sortable: true, resizable: true, hide: false }
      ];
    }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId); 
   if( this.selectCostCenterForCostCenterForCR == 'COST_CENTER_NO_PARAM'){
    this.dataLoadService.load('FG_IN1002_COST_CENTER_LIST').subscribe(arg=>{
      this.costCenterList = arg.body
    });
   }
    else if(this.selectCostCenterForCostCenterForCR){
      this.dataService.getCostCenters(this.selectCostCenterForCostCenterForCR)
      .subscribe(arg => { console.log(arg); this.costCenterList = arg.body });
    }
    else if (this.selectCostCenterForCostCenterForCR) {
      this.dataService.getCostCenters(fixedValues.queryOptions.CostCenterForCR)
        .subscribe(arg => { console.log(arg); this.costCenterList = arg.body });
    }else {
    this.dataService.getCostCenters(fixedValues.queryOptions.CostCenterNO, this.ACC_NO)
      .subscribe(arg => { console.log(arg); this.costCenterList = arg.body });
    }
  }
  itemClick(_item) {
    this.modalShow = false; 
    this.dataObj=_item;
    this.submit.next();
  }

}
